import axios from 'axios'

export default {
  state: {
  },
  mutations: {

  },
  actions: {
    submitProposal({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/proposal', data)
          .then((response) => {
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    checkEmail({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/proposal/email', 
          {
            params: data
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }
  },
  getters: {}
}
